var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _g4, _path17, _path18, _path19, _path20, _g5, _mask, _g6, _mask2, _g7, _mask3, _g8, _mask4, _g9, _mask5, _g10, _mask6, _g11, _mask7, _g12, _path21, _g13, _path22, _path23, _g14, _path24, _path25, _path26, _path27, _path28, _path29, _g15, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g16, _path39, _path40, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 334 318"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 42,
    r: 32,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A5699",
    d: "M283.5 26h2v2.8h11.1a1.2 1.2 0 011.4 1.4v21c0 .6 0 1.4-.3 2-.5.4-1.2.4-1.8.4h-10.3v2.8h-2.2l-15.8-2.8V28.8l15.9-2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M285.5 29.9H297v22.6h-11.4v-2.8h9v-1.4h-9v-1.8h9v-1.4h-9v-1.8h9V42h-9v-1.8h9v-1.4h-9V37h9v-1.4h-9v-1.7h9v-1.4h-9V30zM274.7 36h2l1.4 7 1.3-7.3h2c-.7 3.4-1.4 6.8-2.3 10.2-.5.3-1.4 0-2 0-.6-2.3-1.1-4.6-1.5-7l-1.4 6.8h-2l-1.8-9.4h1.8c.4 2.2.8 4.4 1 6.7.6-2.3 1-4.6 1.5-7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M167 74a32 32 0 100-64 32 32 0 000 64z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M167 58a16 16 0 0016-16h-8a8 8 0 01-8 8v8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M183 42a16 16 0 00-16-16v8a8 8 0 018 8h8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B400",
    d: "M167 58a16 16 0 01-16-16h8a8 8 0 008 8v8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M151 42a16 16 0 0116-16v8a8 8 0 00-8 8h-8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M167 34a4 4 0 100-8 4 4 0 000 8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M167 32a2 2 0 100-4 2 2 0 000 4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B400",
    d: "M151 42a4 4 0 108 0 4 4 0 00-8 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153 42a2 2 0 104 0 2 2 0 00-4 0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M163 54a4 4 0 108 0 4 4 0 00-8 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M165 54a2 2 0 104 0 2 2 0 00-4 0z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M175 42a4 4 0 108 0 4 4 0 00-8 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M177 42a2 2 0 104 0 2 2 0 00-4 0z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 256,
    r: 32,
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4554FF",
    d: "M36.5 244.7c0-.9.7-1.5 1.5-1.5h28c.8 0 1.5.6 1.5 1.5v22.6c0 .9-.7 1.5-1.5 1.5H38c-.8 0-1.5-.6-1.5-1.5v-22.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0091FF",
    d: "M48.3 255.4h-3.9l-.7 2h-2.4l4.1-9.4h1.9l4 9.3h-2.2l-.8-1.9zm-.7-1.8l-1.2-3-1.2 3h2.4zm4.3-5.6h4.2c1 0 1.8.3 2.3.8.6.5.8 1.2.8 2 0 1-.2 1.6-.8 2.1-.6.5-1.3.8-2.3.8h-1.9v3.6H52V248zm3.9 3.9c.8 0 1.3-.4 1.3-1 0-.4-.1-.6-.3-.8-.2-.2-.6-.2-1-.2h-1.6v2h1.6zm4.5-3.9h2.4v9.3h-2.4V248z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M282 181a32 32 0 100-64 32 32 0 000 64z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M273.6 153.1c0 1.9-1.4 3.4-3.1 3.4-1.8 0-3.2-1.5-3.2-3.4 0-1.8 1.4-3.3 3.2-3.3h3.1v3.3zm1.6 0c0-1.8 1.4-3.3 3.2-3.3 1.7 0 3.1 1.5 3.1 3.3v8.4c0 1.9-1.4 3.4-3.1 3.4-1.8 0-3.2-1.5-3.2-3.4v-8.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M278.4 139.7c-1.8 0-3.2-1.5-3.2-3.3 0-1.9 1.4-3.4 3.2-3.4 1.7 0 3.1 1.5 3.1 3.4v3.3h-3.1zm0 1.7c1.7 0 3.1 1.5 3.1 3.3 0 1.9-1.4 3.4-3.1 3.4h-8c-1.7 0-3-1.5-3-3.4 0-1.8 1.3-3.3 3-3.3h8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M291 144.7c0-1.8 1.4-3.3 3.1-3.3 1.7 0 3.2 1.5 3.2 3.3 0 1.9-1.5 3.4-3.2 3.4H291v-3.4zm-1.6 0c0 1.9-1.4 3.4-3.2 3.4-1.7 0-3.1-1.5-3.1-3.4v-8.3c0-1.9 1.4-3.4 3.1-3.4 1.8 0 3.2 1.5 3.2 3.4v8.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M286.2 158.2c1.8 0 3.2 1.5 3.2 3.3 0 1.9-1.4 3.4-3.2 3.4-1.7 0-3.1-1.5-3.1-3.4v-3.3h3.1zm0-1.7c-1.7 0-3.1-1.5-3.1-3.4 0-1.8 1.4-3.3 3.1-3.3h7.9c1.7 0 3.2 1.5 3.2 3.3 0 1.9-1.5 3.4-3.2 3.4h-7.9z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52 181a32 32 0 100-64 32 32 0 000 64z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__a",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-5.6-4-4-5.6z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__b",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M45.6 148.6v11.6h12.8v-11.6H45.6zm5.6 10h-4v-2h4v2zm0-3.2h-4v-2h4v2zm0-3.2h-4v-2h4v2zm5.6 6.4h-4v-2h4v2zm0-3.2h-4v-2h4v2zm0-3.2h-4v-2h4v2z"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__c",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-group_svg__paint0_linear)",
    d: "M55.9 140.3l8.9 8.9V141l-8.9-.7z"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__d",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-group_svg__pattern0)",
    d: "M53.6 129.8H68v14.4H53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87CEAC",
    d: "M55.2 131.4v7.2c0 1.3 1 2.4 2.4 2.4h7.2l-9.6-9.6z"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__e",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M41.6 131.4c-1.3 0-2.4 1-2.4 2.4v.2c0-1.3 1-2.4 2.4-2.4h13.6v-.2H41.6z"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__f",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M62.4 166.4H41.6c-1.3 0-2.4-1-2.4-2.4v.2c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4v-.2c0 1.3-1 2.4-2.4 2.4z"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__g",
    width: 26,
    height: 36,
    x: 39,
    y: 131,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "M57.6 141c-1.3 0-2.4-1-2.4-2.4v.2c0 1.3 1 2.4 2.4 2.4h7.2v-.2h-7.2z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-group_svg__paint1_radial)",
    d: "M55.2 131.4H41.6c-1.3 0-2.4 1-2.4 2.4v30.4c0 1.3 1 2.4 2.4 2.4h20.8c1.3 0 2.4-1 2.4-2.4V141l-9.6-9.6z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter5_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 256,
    r: 32,
    fill: "#fff"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F80ED",
    fillRule: "evenodd",
    d: "M153.7 246l12.3-1v10h-12.3v-9zm14.3-1l12.3-1v11H168v-10zm-14.3 12H166v10l-12.3-1v-9z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F80ED",
    d: "M168 257h12.3v11l-12.3-1v-10z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M282 288a32 32 0 100-64 32 32 0 000 64z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0066DA",
    d: "M268.4 266.3l1.4 2.4c.3.6.7 1 1.2 1.3l5-8.8h-10c0 .5.1 1.1.4 1.6l2 3.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M282 250.8l-5-8.8c-.5.3-1 .7-1.2 1.3l-9.4 16.2c-.3.5-.4 1.1-.4 1.7h10l6-10.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00832D",
    d: "M282 250.8l5-8.8c-.5-.3-1-.4-1.6-.4h-6.8c-.6 0-1.1.2-1.6.4l5 8.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FC",
    d: "M288 261.2h-12l-5 8.8c.5.3 1.1.4 1.7.4h18.6c.6 0 1.2-.2 1.7-.4l-5-8.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M293 270c.5-.3.9-.7 1.2-1.3l.6-1 2.8-4.9c.3-.5.4-1 .4-1.6h-10l5 8.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "M293 251.4l-4.8-8.1c-.2-.6-.7-1-1.2-1.3l-5 8.8 6 10.4h10c0-.6-.2-1.2-.5-1.7l-4.6-8.1z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52 74a32 32 0 100-64 32 32 0 000 64z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M66 53.2H38c-1 0-2-.9-2-2v-20c0-1 .9-1.9 2-1.9h28c1 0 2 .9 2 2v19.9a2 2 0 01-2 2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M40 53.2l12-9.5v-.5l-12.3-8.8v18.4l.3.4z",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D54B3D",
    d: "M38 53.2a2 2 0 01-2-2v-20c0-1 .9-1.2 2-1.2s2 .2 2 1.3v21.9h-2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D72B27",
    d: "M38 30.2c1.4 0 1.7.5 1.7 1V53H38c-1 0-1.7-.8-1.7-1.7v-20c0-.6.3-1 1.7-1zm0-.2c-1.1 0-2 .2-2 1.3v19.9c0 1.1.9 2 2 2h2v-22c0-1-.9-1.2-2-1.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D54B3D",
    d: "M66 53.2h-2v-22c0-1.1.8-1.2 2-1.2 1 0 2 .1 2 1.2v20c0 1.1-1 2-2 2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D72B27",
    d: "M66 30.2c1.2 0 1.7.3 1.7 1v20c0 1-.8 1.7-1.7 1.7h-1.8V31.2c0-.7.5-1 1.8-1zm0-.2c-1.2 0-2 .1-2 1.2v22h2a2 2 0 002-2v-20c0-1.1-1-1.2-2-1.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-group_svg__paint2_linear)",
    d: "M57.4 53.2L36.2 32l1 .4 15 10.6L68 31.5v19.7c0 1.1-1 2-2 2h-8.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#D54B3D",
    d: "M52 43.7L36.9 32.9c-1-.7-1.2-1.9-.5-2.8.6-.8 2-1 2.8-.4L52 39l12.8-9.3a2 2 0 012.8.4 2 2 0 01-.4 2.8L52 43.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#D72B27",
    d: "M66 29.5c.5 0 1 .2 1.4.7.5.7.3 1.8-.4 2.3L52 43.4 37 32.7c-.7-.6-1-1.7-.4-2.4.3-.4.9-.7 1.4-.7.4 0 .8.1 1 .3L51.9 39l.2.2.1-.2L65 29.8a2 2 0 011-.3zm0-.3a2 2 0 00-1.2.4L52 38.8l-12.8-9.1a2 2 0 00-1.2-.4 2 2 0 00-1.7.8c-.6.9-.3 2.1.6 2.8l15 10.8 15.2-10.9a2 2 0 00-1.1-3.6z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-group_svg__filter8_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 149,
    r: 59,
    fill: "#fff"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ECF8E",
    fillRule: "evenodd",
    d: "M181.6 144.3c-.5 0-1 .2-1.2.4-.4.3-.5.7-.5 1.3v.3h2.3v3h-2.3v8.5h-4.3v-8.5h-2.1v-3h2.1v-.3c0-1.6.5-2.8 1.3-3.7.8-.9 2-1.3 3.6-1.3 1 0 1.6.1 2.2.3v3.2a5 5 0 00-1.1-.2zm14 2v11.5h-4.2v-1.5c-.3.5-.8 1-1.5 1.2a5 5 0 01-2.1.5c-1 0-2-.2-2.7-.7a5 5 0 01-1.9-2.1 7 7 0 01-.6-3.1c0-1.2.2-2.3.6-3.2.5-1 1.1-1.6 1.9-2.2.8-.5 1.7-.7 2.7-.7.8 0 1.5.1 2.1.5.7.3 1.2.7 1.5 1.3v-1.5h4.2zm-6.5 8.6a2 2 0 001.7-.7c.4-.5.6-1.2.6-2.2 0-1-.2-1.7-.6-2.2a2 2 0 00-1.7-.7 2 2 0 00-1.7.8c-.5.5-.7 1.2-.7 2.2 0 .9.2 1.6.6 2.1.4.5 1 .7 1.8.7zm15.8-3l5.1 6h-5l-2.5-3.2-2.5 3.1h-4.9l5-6-4.7-5.5h5l2.1 2.8 2.2-2.8h5l-4.8 5.6z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#09F",
    fillRule: "evenodd",
    d: "M126.7 156.4c1.1 1 2.7 1.6 4.7 1.6 1 0 1.9-.1 2.7-.4.9-.2 1.6-.5 2-1l-1-2.8a5 5 0 01-3 1.1c-1 0-1.6-.2-2-.7-.6-.5-.8-1.2-.8-2.2 0-1 .2-1.7.7-2.2.5-.5 1.2-.7 2-.7l1.6.3c.6.2 1 .5 1.5.8l1-2.8c-.4-.5-1-.8-2-1a9 9 0 00-2.5-.4c-1.3 0-2.5.2-3.5.7-1 .5-1.7 1.3-2.3 2.2-.5.9-.8 2-.8 3.2 0 1.8.6 3.3 1.7 4.3zm12.5.9c1 .5 2.1.7 3.4.7 1.3 0 2.5-.2 3.4-.7 1-.5 1.8-1.2 2.3-2.1.5-1 .8-2 .8-3.2 0-1.2-.3-2.3-.8-3.2a5.3 5.3 0 00-2.3-2c-1-.6-2-.8-3.4-.8-1.3 0-2.4.2-3.4.7-1 .5-1.8 1.2-2.3 2-.5 1-.8 2-.8 3.3 0 1.2.3 2.3.8 3.2.5.9 1.3 1.6 2.3 2zm3.4-2.4c1.5 0 2.3-1 2.3-3 0-1-.2-1.7-.6-2.1-.3-.5-1-.7-1.7-.7-.8 0-1.3.2-1.7.7-.4.4-.6 1.2-.6 2.2 0 1 .2 1.7.6 2.2.4.5 1 .7 1.7.7zm8.7 1.5c1.2 1 2.7 1.6 4.7 1.6 1 0 2-.1 2.8-.4.8-.2 1.5-.5 2-1l-1-2.8a5 5 0 01-3.1 1.1c-1 0-1.6-.2-2-.7-.5-.5-.8-1.2-.8-2.2 0-1 .3-1.7.7-2.2.5-.5 1.2-.7 2-.7.6 0 1.1.1 1.7.3l1.4.8 1.1-2.8c-.5-.5-1.2-.8-2-1a9 9 0 00-2.6-.4c-1.3 0-2.4.2-3.4.7-1 .5-1.8 1.3-2.3 2.2-.6.9-.9 2-.9 3.2 0 1.8.6 3.3 1.7 4.3zm16 1.6c-1.4 0-2.5-.2-3.5-.7-1-.5-1.7-1.2-2.3-2.1-.5-1-.8-2-.8-3.2 0-1.2.3-2.3.8-3.2.6-1 1.3-1.6 2.3-2.1 1-.5 2.1-.7 3.5-.7 1.3 0 2.4.2 3.4.7 1 .5 1.7 1.2 2.2 2.1.6.9.8 2 .8 3.2 0 1.2-.2 2.3-.8 3.2-.5.9-1.3 1.6-2.2 2-1 .6-2.1.8-3.4.8zm2.2-6c0 2-.7 3-2.2 3-.8 0-1.4-.3-1.8-.8-.4-.5-.6-1.2-.6-2.2 0-1 .2-1.8.6-2.2.4-.5 1-.7 1.8-.7.7 0 1.3.2 1.7.7.3.4.5 1.2.5 2.2z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter0_d",
    width: 104,
    height: 104,
    x: 230,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter1_d",
    width: 104,
    height: 104,
    x: 115,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter2_d",
    width: 104,
    height: 104,
    x: 0,
    y: 214,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter3_d",
    width: 104,
    height: 104,
    x: 230,
    y: 107,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter4_d",
    width: 104,
    height: 104,
    x: 0,
    y: 107,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter5_d",
    width: 104,
    height: 104,
    x: 115,
    y: 214,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter6_d",
    width: 104,
    height: 104,
    x: 230,
    y: 214,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter7_d",
    width: 104,
    height: 104,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633507 0 0 0 0 0.74825 0 0 0 0 0.854167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-group_svg__filter8_d",
    width: 166,
    height: 166,
    x: 84,
    y: 72,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0 0.698039 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-group_svg__paint0_linear",
    x1: 60.4,
    x2: 60.4,
    y1: 141.1,
    y2: 149.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-group_svg__paint2_linear",
    x1: 36.2,
    x2: 68,
    y1: 42.3,
    y2: 42.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-group_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(40 132.1) scale(41.2796)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

export default __webpack_public_path__ + "static/icon-group.d615148c.svg";
export { SvgIconGroup as ReactComponent };